import React, { useState, useEffect } from "react";
import { Input, Checkbox, Button, Table, Modal, DatePicker } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { allTemplatesAPI, sendAllAssessments } from "../../api/api";
import "./assessmentPage.css";
import EditAssessment from "./EditAssessment";
import LoadingSpiner from "../Common/LoadingSpiner";
import SendSelected from "./SendSelected";
import SendTest from "./SendTest";

const AllAssessments = () => {
  const token = localStorage.getItem("token");
  const [searchText, setSearchText] = useState("");
  const [selectedTests, setSelectedTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState();
  const [edit, setEdit] = useState(false);
  const [data, setData] = useState([]); // Initial empty array
  const [displayedData, setDisplayedData] = useState([]); // Also initialized to empty array
  const [windowHeight, setWindowHeight] = useState(window.innerHeight - 400);
  const [visiblePanel, setVisiblePanel] = useState(null); // State to track visible panel
  const [modalVisible, isModalVisible] = useState(false);
  const [singleModalVisible, isSingleModalVisible] = useState(false);
  const [assignedDate, setAssignedDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [currentTest, setCurrentTest] = useState([]);
  const [selectedTemplates, setSelectedTemplates] = useState([]);

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [token]);

  useEffect(() => {
    if (data.length > 6) {
      setWindowHeight(window.innerHeight);
    }
  }, [data]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await allTemplatesAPI();
      if (res && Array.isArray(res)) {
        setData(res);
        setDisplayedData(res);
      } else {
        throw new Error("Received data is not an array");
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setData([]);
      setDisplayedData([]);
    }
    setLoading(false);
  };

  const onSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (data != undefined) {
      // Additional safeguard
      const filteredData = data.filter(
        (entry) =>
          entry.title && entry.title.toLowerCase().includes(value.toLowerCase())
      );

      setDisplayedData(filteredData);
    }
  };

  const onSendSelected = () => {
    isModalVisible(true);
  };

  const sendThisTest = (test) => {
    setCurrentTest(test);
    isSingleModalVisible(true);
  };

  const onSelectAllChange = (e) => {
    if (!data || data.length === 0) return; // Early exit if no data

    if (e.target.checked) {
      const allTestIds = data.map((item) => item._id); // Assuming '_id' is the identifier
      setSelectedTests(allTestIds);
      setSelectedTemplates(data);
    } else {
      setSelectedTests([]);
      setSelectedTemplates([]);
    }
  };

  const editTest = (_id) => {
    setEdit(true);
    setEditId(_id);
  };

  const onTestSelectChange = (e, key) => {
    const newSelectedTests = e.target.checked
      ? [...selectedTests, key]
      : selectedTests.filter((itemKey) => itemKey !== key);
    setSelectedTests(newSelectedTests);
  };

  const togglePanel = (key) => {
    setVisiblePanel(visiblePanel === key ? null : key);
  };

  const isAllSelected = data.length > 0 && selectedTests.length === data.length;

  if (!edit) {
    if (loading) {
      return <LoadingSpiner loading={loading} />;
    } else {
      return (
        <div
          style={{
            backgroundColor: "white",
            height: "100%",
            margin: "50px",
            paddingBottom: "50px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>
              <h1
                style={{
                  fontSize: "40px",
                  fontWeight: "500",
                  float: "left",
                  margin: "40px",
                  justifySelf: "flex-start",
                }}
              >
                Assessments
              </h1>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{ width: "100%", display: "flex", flexDirection: "row" }}
              >
                <Checkbox
                  onChange={onSelectAllChange}
                  checked={isAllSelected}
                  disabled={!data || !data.length} // Check for data presence and disable if absent
                  style={{ margin: "20px 16px" }}
                >
                  Select All
                </Checkbox>
                <div style={{ marginTop: "15px" }}>
                  <button
                    onClick={onSendSelected}
                    style={{
                      margin: 0,
                      fontSize: "80%",
                      width: "100%",
                      padding: 5,
                    }}
                    className="sendAssessmentButton"
                    disabled={selectedTests.length === 0} // Disable button if no tests are selected
                  >
                    Send Selected Assessments
                  </button>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Input
                  placeholder="Search by name..."
                  value={searchText}
                  onChange={onSearch}
                  style={{ margin: 16, width: "40%", float: "left" }}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            <hr
              style={{
                border: "1px solid #DCDCDC",
                marginTop: "20px",
                width: "100%",
              }}
            />
            <div
              style={{ width: "100%", marginRight: "15px", marginLeft: "15px" }}
            >
              <button
                className="addAssessmentButton"
                onClick={() => (window.location.href = "/assessment-form")}
              >
                New Assessment
              </button>
              {displayedData && displayedData.length > 0 ? ( // Conditional rendering based on displayedData
                displayedData.map((item) => (
                  <div key={item._id} style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "white",
                          padding: "10px",
                          width: "100%",
                          borderRadius: "15px",
                          borderColor: "black",
                          borderWidth: ".5px",
                          marginTop: "10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <label className="circular-checkbox">
                            <input
                              type="checkbox"
                              onChange={(e) => onTestSelectChange(e, item._id)}
                              checked={selectedTests.includes(item._id)}
                              className="custom-checkbox"
                            />
                            <span className="checkmark"></span>
                          </label>
                          <h1
                            style={{
                              textAlign: "left",
                              fontSize: "20px",
                              padding: "0px",
                              color: "black",
                              fontWeight: "600",
                              paddingLeft: "15px",
                            }}
                          >
                            {item.title}
                          </h1>

                          <p>{item.purpose}</p>
                          <div
                            style={{
                              marginLeft: "auto",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <button
                              onClick={() => editTest(item._id)}
                              className="editButton"
                            >
                              Edit Test
                            </button>
                            <button
                              onClick={() => sendThisTest(item)}
                              className="sendButton"
                            >
                              Send Test
                            </button>
                            <Button
                              type="link"
                              onClick={() => togglePanel(item._id)}
                            >
                              <DownOutlined />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {visiblePanel === item._id && (
                      <div
                        style={{
                          backgroundColor: "#F2F2F2",
                          padding: "10px",
                          width: "100%",
                          borderRadius: "15px",
                          borderColor: "black",
                          borderWidth: ".5px",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                          }}
                        >
                          <Table
                            dataSource={item.details} // Assuming each item has a 'details' field with an array of data
                            columns={[
                              {
                                title: "Pending Users",
                                dataIndex: "attribute1",
                                key: "attribute1",
                              },
                              {
                                title: "Date Assigned",
                                dataIndex: "attribute2",
                                key: "attribute2",
                              },
                              // Add more columns as needed
                            ]}
                            pagination={false}
                          />
                          <Table
                            dataSource={item.details} // Assuming each item has a 'details' field with an array of data
                            columns={[
                              {
                                title: "Completed Users",
                                dataIndex: "attribute1",
                                key: "attribute1",
                              },
                              {
                                title: "Date Completed",
                                dataIndex: "attribute2",
                                key: "attribute2",
                              },
                              {
                                title: "Score",
                                dataIndex: "attribute2",
                                key: "attribute2",
                              },
                              // Add more columns as needed
                            ]}
                            pagination={false}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginTop: "20px",
                  }}
                >
                  {loading ? "Loading assessments..." : "No assessments found."}
                </p>
              )}
            </div>
          </div>

          {modalVisible && (
            <SendSelected
              isVisible={modalVisible}
              setIsVisible={isModalVisible}
              selectedTemplates={selectedTests}
            />
          )}
          {singleModalVisible && (
            <SendTest
              isVisible={singleModalVisible}
              setIsVisible={isSingleModalVisible}
              selectedTemplate={currentTest}
            />
          )}
        </div>
      );
    }
  } else {
    return <EditAssessment _id={editId} />;
  }
};
export default AllAssessments;
